import React from 'react';
import './AuthLayout.scss';

const AuthLayout = ({ children }) => {
    return (
        <div className="auth-layout">
            <div className="auth-container">
                <div className="auth-header">
                    <h1>Sloot</h1>
                    <p>Welcome to your Super share system</p>
                </div>
                <div className="auth-content">
                    {children}
                </div>
                <div className="auth-footer">
                    <p>&copy; 2025 Sloot.</p>
                </div>
            </div>
        </div>
    );
};

export default AuthLayout;